import Controller from '@ember/controller';
import { action } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import dateUtils from 'donor-elf-web/lib/date-utils';
import moment from 'moment';

export default class DashboardTotalController extends Controller {
  @service fundsService;
  @service router;

  @alias('model.goal') goal;
  @alias('goal.goalData') goalData;

  get timeLeftToRaiseLabel() {
    let goalDate = dateUtils.deserializeDateOnly(this.goalData.goal_date);
    let duration = moment.duration(moment().diff(goalDate));
    let label = null;
    if (Math.abs(duration.asMonths()) >= 2) {
      label = `${Math.abs(Math.round(duration.asMonths()))} months`;
    } else if (Math.abs(duration.asWeeks()) >= 2) {
      label = `${Math.abs(Math.round(duration.asWeeks()))} weeks`;
    } else {
      label = `${Math.abs(Math.round(duration.asDays()))} days`;
    }
    if (duration.asDays() < 0) {
      label = `${label} left`;
    } else {
      label = `${label} overdue`;
    }
    return label;
  }

  @action
  handleDonutChartClicked() {
    this.router.transitionTo('funds.fund.transactions');
  }
}
